import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";

import { StyledNavButton } from "../components/SmallComponents/AppComponents";
import { Link } from "react-router-dom";
import { bucket } from "../components/SmallComponents/Images";

const swiperData = [
  {
    img: bucket,
    title: "The Barf Bucket",
    describe: (
      <span>
        Stake
        <span style={{ fontWeight: "700" }}> BARFBOY</span> for an APY of up to
        60%. <br /> Note: 2% fee will apply on every deposit.
      </span>
    ),
    btn: "Join Stake",
    link: "https://stake.barfboymemecoin.com/",
  },
];
export default function Features() {
  const matches = useMediaQuery("(max-width:950px)");
  const matchesTwo = useMediaQuery("(max-width:400px)");
  const matchesThree = useMediaQuery("(max-width:413px)");
  return (
    <Box py={matches ? 5 : 10}>
      <Container>
        <Typography
          sx={{
            fontFamily: "Lilita One",
            fontSize: { xs: "45px", sm: "70px" },
            lineHeight: { xs: "40px", sm: "30px" },
            textAlign: "center",
            color: "#65CD2E",
            WebkitTextStroke: "3px #ffffff",
          }}
        >
          The Barf Bucket
        </Typography>

        <Box pt={matches ? 5 : 10}>
          <Grid container spacing={10} display="flex" justifyContent="center">
            {swiperData.map(({ title, img, describe, btn, link }, index) => {
              return (
                <Grid item xs={12} md={6} key={index}>
                  <Box
                    m={"auto"}
                    sx={{
                      background: "#27ADFB",
                      borderRadius: "40px",
                      boxShadow:
                        "2px 2px 3px 0px #00000080 inset,-2px -2px 4px 0px #FFFFFF80 inset",
                      width: "90%",
                      height: "100%",
                      p: 2,
                      position: "relative",
                      "&:hover": {
                        background: "#65CD2E",
                        boxShadow:
                          "2px 2px 3px 0px #FFFFFF80 inset,-2px -2px 4px 0px #00000080 inset",
                      },
                    }}
                  >
                    <Typography
                      pt={2}
                      sx={{
                        textAlign: "center",
                        fontFamily: "Lilita One",
                        fontSize: { md: "36px", xs: "26px" },
                        fontWeight: "400",
                        color: "#fff",
                      }}
                    >
                      {title}
                    </Typography>
                    <Box display="flex" justifyContent="center">
                      <img src={img} width={"70%"} alt="" />
                    </Box>
                    <Typography
                      pt={index === 1 ? 3.2 : index === 2 ? 2.9 : 2}
                      px={2}
                      sx={{
                        textAlign: "center",
                        fontFamily: "Montserrat",
                        fontSize: { md: "16px", xs: "14px" },
                        fontWeight: "400",
                        color: "#fff",
                      }}
                    >
                      {describe}
                    </Typography>
                    <Box
                      mt={{
                        xs:
                          index === 0
                            ? matchesTwo
                              ? matchesThree
                                ? 5
                                : 7
                              : 3
                            : index === 1
                            ? matchesTwo
                              ? 7
                              : 6
                            : matchesThree
                            ? 3
                            : 1,
                        sm: index === 1 ? 7 : 4,
                      }}
                      display="flex"
                      justifyContent="center"
                    >
                      {link ? (
                        <Link to={link} style={{ textDecoration: "none" }}>
                          {" "}
                          <StyledNavButton
                            width="190px"
                            style={{
                              fontWeight: "700",
                              marginTop:
                                matches && index === 2 ? "20px" : "0px",
                            }}
                          >
                            {btn}{" "}
                          </StyledNavButton>
                        </Link>
                      ) : (
                        <StyledNavButton
                          width="190px"
                          style={{
                            fontWeight: "700",
                            marginTop: matches && index === 2 ? "20px" : "0px",
                          }}
                        >
                          {btn}{" "}
                        </StyledNavButton>
                      )}
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
